import React, { ReactElement } from "react";
import { ensure, Icon } from "sprint-common-web";

import { CloudFileListingItem } from "../types/CloudFileListingItem";

export const renderIsCloudFileNotificationApproved = (item?: CloudFileListingItem): ReactElement | null => {
    ensure(item);

    if (item.isNotificationApproved) {
        return <Icon iconName="Accept" />;
    }

    return <Icon iconName="Cancel" />;
};
